var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sf-link',{class:{
    orange: _vm.color === 'orange',
    'no-action': _vm.hasNoAction,
    secondary: _vm.variant === 'secondary',
    small: _vm.variant === 'small',
    bold: _vm.bold
  },attrs:{"link":_vm.link || '/',"color":_vm.color,"variant":_vm.variant,"target":_vm.targetLink}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }